import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// constants
import routesConfig from 'constants/routesConfig.json';

// components
import ConfirmDialog from 'shared/ConfirmDialog';

// hooks
import { useDeleteProfileMutation } from 'teamProfiles/hooks/teamApi';
import { Profile } from 'teamProfiles/_types';

interface DeleteProfileModalProps {
  isOpen: boolean;
  onClose: () => void;
  profile: Profile;
}

export default function DeleteProfileModal({
  isOpen,
  onClose,
  profile,
}: DeleteProfileModalProps): JSX.Element {
  const history = useHistory();
  const { t } = useTranslation('pageTeam');
  const { mutateAsync: deleteProfile } = useDeleteProfileMutation();

  const handleDelete = async () => {
    await deleteProfile(profile.id);
    onClose();
    history.push(routesConfig.TEAM_PAGE);
  };

  return (
    <ConfirmDialog
      isOpen={isOpen}
      handleClose={onClose}
      title={t('deleteMember.title')}
      contentText={t('deleteMember.confirmMessage', {
        name: profile.full_name,
      })}
      successCallback={handleDelete}
      successLabel={t('deleteMember.delete')}
      cancelLabel={t('deleteMember.cancel')}
    />
  );
}
